import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function QrPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const data = searchParams.get("data");

  useEffect(() => {
    if (data) {
      // redirecting user
      window.location.replace(`https://api.travelchamp.com/qrinfo?data=${data}`);
      // OR if you want internal navigation within your React app:
    //   navigate(`/qrinfo?data=${data}`);
    }
  }, [data]);

  return null;
}
